export interface RecommendationProps {
  intervalCode: string;
  itemSequence: string;
  observationDescription?: string;
  statusItem: string;
}

export const RecommendationStatusItem = {
  ADMINISTERED: 'ADMINISTERED',
  RECOMMENDATION_ADMINISTERED: 'A'
}
